import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { MDBContainer, MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink } from "mdbreact";
import UserEmailAddForm from './FormUserEmail';
import PermissionAddEditForm from '../Permission/FormUserPermission';
import ListUserLog from './FormUserLog';

class ModalForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      activeItem: "1"
    }
  }

  toggleTab = tab => e => {
    if (this.state.activeItem !== tab) {
      this.setState({
        activeItem: tab
      });
    }
  };

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }))
  }

  render() {

    let closeBtn = '';
    let toggle = '';

    closeBtn = <button className="close" onClick={this.toggle}>&times;</button>
    toggle = this.toggle

    const label = this.props.buttonLabel

    let button = ''
    let title = ''

    if (label === 'NOVO') {
      button = <button
        className="btn btn-dommus-action"
        onClick={this.toggle}
        style={{ marginRight: "10px" }}>
        <i className="fa fa-plus-circle" aria-hidden="true"></i>{label}
      </button>
      title = 'Adicionar novo usuário'
    } else {
      button = <p className="dropdown-item table-remove"
        to="#"
        onClick={this.toggle} style={{ width: "100px" }}>
        Editar <i style={{color: "blue"}} className="fas fa-edit"></i>
      </p>
      title = 'Editar usuário'
    }

    return (
      <div>
        {button}
        <Modal isOpen={this.state.modal} toggle={toggle} className={this.props.className}>
          <ModalHeader toggle={toggle} close={closeBtn}>{title}</ModalHeader>
          <ModalBody>
            <MDBContainer style={{ marginTop: '-50px' }}>
              <MDBNav className="nav-tabs mt-5">
                {label === 'NOVO' ?
                  <>
                    <MDBNavItem>
                      <MDBNavLink link to="#" active={this.state.activeItem === "1"} onClick={this.toggleTab("1")} role="tab" >
                        Cadastro
                      </MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                      <MDBNavLink link to="#" active={this.state.activeItem === "2"} onClick={this.toggleTab("2")} role="tab" >
                        Permissões
                    </MDBNavLink>
                    </MDBNavItem>
                  </>
                  : ''}

                {label === 'NOVO' ? '' :
                  <>
                    <MDBNavItem>
                      <MDBNavLink link to="#" active={this.state.activeItem === "1"} onClick={this.toggleTab("1")} role="tab" >
                        Permissões
                      </MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                      <MDBNavLink link to="#" active={this.state.activeItem === "2"} onClick={this.toggleTab("2")} role="tab" >
                        Log
                      </MDBNavLink>
                    </MDBNavItem>
                  </>
                }
              </MDBNav>
              <MDBTabContent activeItem={this.state.activeItem} >
                <MDBTabPane tabId="1" role="tabpanel">
                  {label === 'NOVO' ?
                    <UserEmailAddForm /> : <PermissionAddEditForm edit={true} user={this.props.user} />}
                </MDBTabPane>
                <MDBTabPane tabId="2" role="tabpanel">
                  {label === 'NOVO' ? <PermissionAddEditForm edit={false}/> : <ListUserLog user={this.props.user}/>}
                </MDBTabPane>
              </MDBTabContent>
            </MDBContainer>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}
export default ModalForm